import {Component, Input} from '@angular/core';
import { AverageLengthSubscription } from '../../../../../entities/statistic.entity';

@Component({
  selector: 'app-dashboard-misc-list-average-length-subscription',
  templateUrl: './list-average-length-subscription.html'
})
export class ListAverageLengthSubscriptionComponent {

  @Input()
  averages: AverageLengthSubscription[] = [];
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/dashboard/misc/list-average-length-subscription/list-average-length-subscription.component.ts